import { useRef, useCallback } from 'react'

/**
 * Minimal custom hook to debounce a function call.
 * 
 * Usage:
 *   const debounced = useDebounceCallback((val) => {
 *     setGlobalFilter(val || undefined)
 *   }, 200)
 * 
 * Then call debounced(value) whenever user types.
 */
function useDebounceCallback(callback, wait = 200) {
  const timeoutRef = useRef(null)

  return useCallback(
    (...args) => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
      timeoutRef.current = setTimeout(() => {
        callback(...args)
      }, wait)
    },
    [callback, wait]
  )
}

export default useDebounceCallback